<script>
import checkoutCart from '~/mixins/checkoutCart.vue'

export default {
  name: 'CheckoutCartByIdAndShortsiteCode',
  serverCacheKey() {
    return false
  },
  mixins: [checkoutCart],

  async fetch() {
    try {
      // you could test if with a URL
      // http://localhost:3000/checkout/cart/77d1a704-5f7e-416a-ab36-79621dfccec6/VOC1
      console.log('CHCKEOUT/CART/_ID/_SHORTSITECODE Entry Point')
      console.log('CHCKEOUT/CART/_ID/_SHORTSITECODE params=', this.$route.params)

      const id = this.$route?.params?.id
      const shortsitecode = this.$route?.params?.shortsitecode
      const useCache = false

      if (!Object.keys(this.$route.params).length) {
        return
      }
      if (!id || !shortsitecode) {
        return
      }

      this.$store.commit('basket/id', undefined)
      this.$store.commit('basket/payload', undefined)
      this.$store.commit('cart/CartId', undefined)
      this.$store.commit('cart/updatedAt', undefined)

      console.log(`CHCKEOUT/CART/_ID/_SHORTSITECODE id=${id} shortsitecode=${shortsitecode} useCache=${useCache}`)

      // Calling the Frontend Api for the Basket (we have axios-cache LRU in place)
      process.env.NODE_ENV !== 'production' && require('axios-debug-log')

      // BASKET API
      console.info(`GET '${this.$config.APIProxyURL}/basket/id/${id}'`)
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${this.$config.APIProxyURL}/basket/id/${id}`,
        headers: {
          ...(this.$config.APIProxyAPIkey && { 'x-internal-proxy': this.$config.APIProxyAPIkey }),
          'Cache-Control': useCache ? 'max-age=3600' : 'max-age=0',
          'Content-Type': 'application/json'
        }
      }

      const payload = await this.$axios
        .request(config)
        .then(response => {
          const basket = response?.data?.payload
          console.log('CHCKEOUT/CART/_ID/_SHORTSITECODE OK basket=', basket)
          const foundOffer = basket.items.find(element => {
            const elShortsitecode = element?.shortsite_code?.toLowerCase()
            if (shortsitecode.toLowerCase() === elShortsitecode) {
              console.log(`CHCKEOUT/CART/_ID/_SHORTSITECODE CHECKS FOUND element.shortsite_code=${element.shortsite_code}`)
              this.$store.commit('basket/payload', basket)
              this.$store.commit('cart/CartId', id)
              this.$store.commit('cart/updatedAt', new Date())
              this.$store.commit('basket/id', id)
              this.$store.commit('cart/minisite', basket?.minisite)
              return basket
            }
          })

          if (!foundOffer) {
            console.error(`CHCKEOUT/CART/_ID/_SHORTSITECODE CHECKS ERROR`)
            this.$store.commit('basket/id', undefined)
            this.$store.commit('cart/CartId', undefined) // DROP the CartId
            this.$store.commit('cart/updatedAt', undefined)
            this.$store.commit('basket/payload', undefined)
            this.$store.commit('cart/minisite', undefined)
          }

          return basket
        })
        .catch(error => {
          console.log('CHCKEOUT/CART/_ID/_SHORTSITECODE AXIOS error=', error)
          this.$store.commit('basket/id', undefined)
          // commit('cart/CartId', undefined) // DROP the CartId
          this.$store.commit('cart/updatedAt', undefined)
          this.$store.commit('basket/payload', undefined)
          this.$store.commit('cart/minisite', undefined)
          return undefined
        })

      // Get the lates version of the Upsell List
      payload?.id && (await this.$store.dispatch('GET_UPSELL_MONGODB', { skip: false }))

      this.$nuxt.$emit('TOGGLE_LOADING', false)

      // if (payload.id) {
      // window.location.href = `${this.$config.baseURL}/checkout/cart`
      // }
      return payload
    } catch (error) {
      console.log('CHCKEOUT/CART/_ID/_SHORTSITECODE error=', error)
      this.$store.commit('basket/id', undefined)
      this.$store.commit('cart/CartId', undefined)
      this.$store.commit('cart/updatedAt', undefined)
      this.$store.commit('basket/payload', undefined)
      this.$nuxt.$emit('TOGGLE_LOADING', false)
      return false
    }
  },
  asyncData({ store, route, params, query, $ua, redirect, $nuxt }) {
    // Fill the Abandoned Basket data attributes
    return {
      abandonedBasket: params,
      isLoading: false,
      isAValidAbandonedBasket: false
    }
  }
}
</script>
